

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { TechniqueDifficulty, TechniqueType } from '@/types/technique';
import { PenLine } from 'lucide-react';

interface TechniqueCardBadgesProps {
  position?: string;
  type?: TechniqueType;
  level?: TechniqueDifficulty;
  isUserCreated?: boolean;
}

export const TechniqueCardBadges: React.FC<TechniqueCardBadgesProps> = ({
  position,
  type,
  level,
  isUserCreated = false,
}) => {
  return (
    <div className="flex flex-wrap gap-1.5 mt-1">
      {isUserCreated && (
        <Badge 
          variant="outline" 
          className="bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100 text-[10px] sm:text-xs px-1.5 py-0 h-5 flex items-center font-medium"
        >
          <PenLine className="h-3 w-3 mr-1" />
          Custom
        </Badge>
      )}
      
      {position && (
        <Badge 
          variant="outline" 
          className="bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100 text-[10px] sm:text-xs px-1.5 py-0 h-5"
        >
          {position}
        </Badge>
      )}
      
      {type && (
        <Badge 
          variant="outline" 
          className="bg-purple-50 text-purple-700 border-purple-200 hover:bg-purple-100 text-[10px] sm:text-xs px-1.5 py-0 h-5"
        >
          {type}
        </Badge>
      )}
      
      {level && (
        <Badge 
          variant="outline" 
          className={cn(
            "text-[10px] sm:text-xs px-1.5 py-0 h-5",
            level === 'beginner' && "bg-green-50 text-green-700 border-green-200 hover:bg-green-100",
            level === 'intermediate' && "bg-yellow-50 text-yellow-700 border-yellow-200 hover:bg-yellow-100",
            level === 'advanced' && "bg-red-50 text-red-700 border-red-200 hover:bg-red-100"
          )}
        >
          {level.charAt(0).toUpperCase() + level.slice(1)}
        </Badge>
      )}
    </div>
  );
};
